import { updatePublishedTenderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updatePublishedTenderCallable = getCallable(
  updatePublishedTenderDefinition,
);
